function Hamburger() {

    // Look for .hamburger
    var hamburger = document.querySelector(".hamburger");
    // var bodyDim = document.querySelector(".body-dim");
    var mainNav = document.querySelector("#main-nav");
    var header = document.querySelector("header");

    mainNav.addEventListener("transitionend", function (event) {
        // console.log("Animation has ended: %O", event);
        if (mainNav.classList.contains("closed")) {
            bodyDim.classList.add("hidden");
        }
    });

    // On click
    hamburger.addEventListener("click", function () {
        // Toggle class "is-active"
        hamburger.classList.toggle("is-active");
        // Do something else, like open/close menu

        if (mainNav !== null) {
            mainNav.classList.toggle("closed");
            header.classList.toggle("closed");
            // bodyDim.classList.toggle("show");

            if (bodyDim.classList.contains("show")) {
                // bodyDim.classList.remove("hidden");
            }
        }

    });


}